import React from 'react'
import styled from 'styled-components'
import { MyImage } from '../ui/MyImage'
import { VipIcon } from '~/components/icon/Vip'
import { UserRoleType } from '~/utils'

const StyledCreatorAvatar = styled.div`
  position: relative;
`

export const CreatorAvatar: React.FC<{
  image: string
  userRole: UserRoleType | null | undefined
  size: number
  style?: React.CSSProperties
  className?: string
  iconClassName?: string
}> = ({ image, size, userRole, className, style, iconClassName }) => {
  return (
    <StyledCreatorAvatar
      style={{ height: size, width: size, ...style }}
      className={className}
    >
      <MyImage
        tag="v400"
        className="w-full h-full rounded-[50%]"
        src={image}
        alt=""
      />
      <VipIcon userRole={userRole} className={iconClassName} />
    </StyledCreatorAvatar>
  )
}
